import { ProviderRegistrationConsiderationsEnum } from "@asd/customer-portal-api";
import { Checkbox, FormControlLabel, Stack } from "@mui/material";

import { CONSIDERATION_OPTIONS } from "~/utils/providerRegistrationHelpers";
import FieldError from "./shared/FieldError";
import useExclusiveOption from "./shared/useExclusiveOption";

interface ConsiderationsEditProps {
  value: ProviderRegistrationConsiderationsEnum[];
  onChange: (_val: ProviderRegistrationConsiderationsEnum[]) => void;
  error?: string;
}

const ConsiderationsEdit = ({ value = [], onChange, error }: ConsiderationsEditProps) => {
  const noneKey = ProviderRegistrationConsiderationsEnum.none;
  const { isExclusiveSelected: isNoneSelected, isAnyNonExclusiveSelected: isAnyNonNoneSelected } = useExclusiveOption(value, noneKey);

  return (
    <Stack direction="column">
      {CONSIDERATION_OPTIONS.map(([enumValue, label]) => {
        const isThisNone = enumValue === noneKey;
        const isDisabled = (isNoneSelected && !isThisNone) || (isAnyNonNoneSelected && isThisNone);

        return (
          <FormControlLabel
            key={enumValue}
            control={
              <Checkbox
                checked={value.includes(enumValue)}
                disabled={isDisabled}
                onChange={(e) => {
                  if (!e.target.checked) {
                    onChange(value.filter((v) => v !== enumValue));
                  } else {
                    onChange([...value, enumValue]);
                  }
                }}
              />
            }
            label={label}
          />
        );
      })}
      <FieldError error={error} show={!value?.length} />
    </Stack>
  );
};

export default ConsiderationsEdit;
